import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-research-centre',
  templateUrl: './research-centre.component.html',
  styleUrls: ['./research-centre.component.scss']
})
export class ResearchCentreComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
